module.exports = __webpack_public_path__ + "img/print-receipt-white.bb32155a.svg";